import type { ClientLifecycle, ClientLifecycleStatus } from '~/types/models';

export const CLIENT_LIFECYCLE_STATUS_LABELS: Record<ClientLifecycleStatus, string> = {
    raw_enquiry: 'Raw enquiry',
    lead: 'Lead',
    qualified: 'Qualified',
    prospect: 'Prospect',
    opportunity: 'Opportunity',
    proposal_sent: 'Proposal sent',
    won: 'Won',
    onboarding: 'Onboarding',
    active: 'Active client',
    paused: 'Paused client',
    completed: 'Completed',
    past: 'Past client',
    lost: 'Lost',
    archived: 'Archived',
};

const CLIENT_LIFECYCLE_STATUS_PRIORITY: Record<ClientLifecycleStatus, number> = {
    raw_enquiry: 0,
    lead: 1,
    qualified: 2,
    prospect: 3,
    opportunity: 4,
    proposal_sent: 5,
    won: 6,
    onboarding: 7,
    active: 8,
    paused: 8,
    completed: 9,
    past: 9,
    lost: 9,
    archived: 10,
};

export function normalizeClientLifecycleStatus(value: unknown): ClientLifecycleStatus | undefined {
    const normalized = String(value || '').trim() as ClientLifecycleStatus;
    return normalized && normalized in CLIENT_LIFECYCLE_STATUS_PRIORITY
        ? normalized
        : undefined;
}

export function pickDominantClientLifecycleStatus(
    existingStatus: unknown,
    candidateStatus: unknown,
): ClientLifecycleStatus | undefined {
    const existing = normalizeClientLifecycleStatus(existingStatus);
    const candidate = normalizeClientLifecycleStatus(candidateStatus);

    if (!candidate) {
        return existing;
    }

    if (!existing) {
        return candidate;
    }

    return CLIENT_LIFECYCLE_STATUS_PRIORITY[existing] >= CLIENT_LIFECYCLE_STATUS_PRIORITY[candidate]
        ? existing
        : candidate;
}

export function mergeClientLifecycleStatus(
    existingLifecycle: Partial<ClientLifecycle> | null | undefined,
    candidateStatus: ClientLifecycleStatus,
): ClientLifecycleStatus {
    return pickDominantClientLifecycleStatus(existingLifecycle?.status, candidateStatus) || candidateStatus;
}
